import SubControlBar from "../atoms/SubControlBar";

interface Props {}

export default function MobileFailControlBar({}: Props) {
  return (
    <SubControlBar>
      <div className={""}>
        <h1
          className={
            "font-brik text-4xl leading-none text-red-500 md:text-3xl md:leading-none"
          }
        >
          Incorrect!
        </h1>
        <p className={"text-base leading-tight md:text-base md:leading-tight"}>
          You didn't get this mixpuzzle right, but you'll get the next one!
        </p>
      </div>
    </SubControlBar>
  );
}
